export default "__VITE_ASSET__Ovd6faFQ__"